import { merchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

export const deleteKnowledgeArticle = {
  name: "deleteKnowledgeArticle" as const,
  input: z.object({ id: merchantKnowledgeIdFormat.schema }).strict(),
  output: z.null(),
};
